"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocsTooltipBody = DocsTooltipBody;
var _react = _interopRequireDefault(require("react"));
var _DocsTooltipContent = require("./DocsTooltipContent");
var _DocsTooltipContentSkeletonLoader = require("./DocsTooltipContentSkeletonLoader");
var _DocsTooltipContentError = require("./DocsTooltipContentError");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function DocsTooltipBody(_ref) {
  var isLoading = _ref.isLoading,
    error = _ref.error,
    data = _ref.data,
    classes = _ref.classes,
    showHeader = _ref.showHeader,
    showFooter = _ref.showFooter,
    linkTopicDataId = _ref.linkTopicDataId;
  if (isLoading) {
    return /*#__PURE__*/_react.default.createElement(_DocsTooltipContentSkeletonLoader.DocsTooltipContentSkeletonLoader, null);
  }
  if (error) {
    return /*#__PURE__*/_react.default.createElement(_DocsTooltipContentError.DocsTooltipContentError, {
      classes: classes
    });
  }
  return /*#__PURE__*/_react.default.createElement(_DocsTooltipContent.DocsTooltipContent, {
    showHeader: showHeader,
    showFooter: showFooter,
    data: data,
    classes: classes,
    linkTopicDataId: linkTopicDataId
  });
}